import 'jquery-mask-plugin'; // eslint-disable-next-line no-unused-vars

import config from '@cigna/cigna_digital_dcws_cigna-frontend/src/js/util/config';
import renderTemplate from '@cigna/cigna_digital_dcws_cigna-frontend/src/js/util/template';
import svgTemplate from './views/svg.tpl.html';
import 'parsleyjs';
import { getAPIUrl, prepData } from './utils';
var componentsSvg = "".concat(config.svgPath, "component-sprite.svg");

var setupValidationUI = function setupValidationUI($form) {
  $form.parsley({
    successClass: 'input-success',
    errorClass: 'input-error',
    classHandler: function classHandler(el) {
      return el.$element.closest('.input-holder');
    },
    errorsWrapper: '<div class="error-feedback"></div>',
    errorTemplate: '<p class="error-message"></p>'
  });
  $form.parsley().on('field:error', function (fieldInstance) {
    var svg = renderTemplate(svgTemplate, {
      cls: 'icn m-icn feedback-icn',
      svgSpritePath: componentsSvg,
      icon: 'info-circle'
    });
    var feedbackBox = fieldInstance.$element.next('.error-feedback');

    if (!feedbackBox.find('svg').length) {
      feedbackBox.prepend(svg);
    }
  });
  $form.parsley().on('field:success', function (fieldInstance) {
    var svg = renderTemplate(svgTemplate, {
      cls: 'icn ml-icn validation-icn',
      svgSpritePath: componentsSvg,
      icon: 'check-circle'
    });

    if (!fieldInstance.$element.next('svg.validation-icn').length) {
      fieldInstance.$element.after(svg);
    }
  });
};

export default (function () {
  var form = document.forms.tranzactForm;
  if (!form) return false;
  var $form = $(form);
  var $phoneNumber = $('#phoneNumber');
  var phoneDigits = document.getElementById('phone_digits');
  var actionUrl = getAPIUrl(location.host);
  var data = prepData();
  var submitBtn = form.tranzactSubmit;
  setupValidationUI($form);
  form.setAttribute('action', actionUrl);
  $phoneNumber.mask('(000) 000-0000');
  $form.parsley().on('field:validated', function () {
    var disclaimer = document.getElementById('formDisclaimer');
    var formValid = this.parent.isValid();
    if (this.element.id === 'phoneNumber' && this.isValid()) phoneDigits.value = $(this.element).cleanVal();

    if (formValid) {
      disclaimer.classList.remove('d-none');
      submitBtn.removeAttribute('disabled');
    } else {
      disclaimer.classList.add('d-none');
      submitBtn.setAttribute('disabled', 'disabled');
    }
  });
  form.elements.age.addEventListener('change', function (e) {
    var self = e.target;
    var $ageModal = $('#AgeModal');
    var $formModal = $('#micro-tranzact-form');

    if (self.value === '<64') {
      $formModal.modal('hide');
      $ageModal.modal('show');
      form.elements.age.value = '';
    }
  });
  $('input.basic-input, select.custom-select').change(function (e) {
    $(e.currentTarget).parsley().validate();
  });
  $(document).ajaxSend(function (event, request, settings) {
    if (!settings.url.includes('web-lead')) return false;
    var categories = ['customerInformation', 'additionalInformation', 'identifiers'];
    var formData = $(form).serializeArray();
    var jsonData = data;
    formData.forEach(function (obj) {
      categories.forEach(function (cat) {
        if (obj.name.includes(cat)) JSON.stringify(jsonData[cat][obj.name.replace("".concat(cat, "."), '')] = obj.value || '');
      });
    });
    request.setRequestHeader('Content-type', 'application/json');
    request.setRequestHeader('Accept', 'application/json');
    settings.processData = false;
    settings.dataType = 'json';
    settings.data = JSON.stringify(jsonData);
  });
  $(document).ajaxError(function (event, request, settings) {
    if (!settings.url.includes('web-lead')) return false;
  });
  $(document).ajaxSuccess(function (event, request, settings) {
    if (!settings.url.includes('web-lead')) return false; // eslint-disable-next-line no-undef

    addFloodlight('cigna00', 'csbmi0');
  });
});